import { render, staticRenderFns } from "./PostalCode.vue?vue&type=template&id=8b7abbaa"
import script from "./PostalCode.vue?vue&type=script&lang=js"
export * from "./PostalCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports